'use client';
import React from 'react';
function MioDivider() {
    return (
        <div className="mio-divider app-border"></div>
    )
}
export default MioDivider